/**
 * Enumeration for different field types.
 */
export enum FieldType {
    Numeric = 'numeric',
    Boolean = 'boolean',
    Select = 'select',
}